/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { SectionGroupV2, ConfigToggle } from 'material/expandablesection/v2'
// styles
import injectSheet from 'react-jss'
import styles from './shareemailwithfreestar_styles'


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADMIN SECTION : SHARE EMAIL WITH FREESTAR ~~~~~~~~~~ ========== */
const ShareEmailWithFreestar = injectSheet(styles)((props) => {

  const { shareEmailWithFreestar, onChange } = props

  return (
    <SectionGroupV2
      klass={`${props.classes.shareemailwithfreestar} shareemailwithfreestar`}
      title={'Share Email With Freestar'}
      description={'Share commenter email addresses with Freestar.'}
      indented
    >
      <ConfigToggle
        title={'Share email with Freestar'}
        description={'Allow commenter email addresses to be shared with Freestar.'}
        checked={shareEmailWithFreestar}
        onChange={val => onChange('shareEmailWithFreestar', val)}
      />
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ShareEmailWithFreestar;
